function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.061 11.045l7.297 7.267a2.087 2.087 0 0 1-.88 3.517 2.107 2.107 0 0 1-2.039-.506l-7.4-7.267-7.298 7.267c-.806.86-2.16.907-3.023.104a2.124 2.124 0 0 1-.104-3.01l7.505-7.372L.718 3.778A2.162 2.162 0 0 1 .562.715 2.184 2.184 0 0 1 3.637.559l7.297 7.58 7.61-7.372a2.091 2.091 0 0 1 2.558.348c.67.691.775 1.75.256 2.559l-7.297 7.267v.104z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/cancel.9169356d.svg";
export { SvgComponent as ReactComponent };